import {
  TaskerWorkflow,
  getPreorderWorkflowTraversal,
} from '@scale/shared/taskerWorkflow/TaskerWorkflow';
import { useUpdateEffect } from 'react-use-v13';
import _ from 'lodash';
import { LabelerStateHook } from 'react-scale/hooks/useLabelerState';
import { PartialRecord } from '@scale/shared/types/utils';
import { getPreorderTraversal } from '@scale/shared/annotation/annotationGrouping/getPreorderTraversal';
import { isLabelGroupNode } from '@scale/shared/annotation/annotationGrouping/types';

// TODO: break this out into another file with types
const colorMapToGLPreprocessingIds: PartialRecord<string, number> = {
  color: 0,
  greyscale: 1,
  elevation: 2,
};

const useWorkflowStepActivationEffects = (
  workflow: TaskerWorkflow | undefined,
  labelerStateHook: LabelerStateHook | undefined,
  alertActivationEffect: (message: string) => void,
) => {
  const workflowState = labelerStateHook?.workflowHook.workflowState;
  const annotationsHook = labelerStateHook?.annotationsHook;

  useUpdateEffect(() => {
    if (!workflow || !labelerStateHook || !workflowState) return;
    const allSteps = getPreorderWorkflowTraversal(workflow);
    const activeStep = _.find(allSteps, step => step.id === workflowState.activeStepId);
    _.forEach(activeStep?.activationEffects, activationEffect => {
      if (activationEffect.type === 'selectAnnotation') {
        // TODO: Clear up if this removal is ok. Under the new world, people won't need to selectAnnotation from purely Step
        if (!annotationsHook) {
          return;
        }
        const idOrShortId = activationEffect.target;
        if (!idOrShortId) return;
        const ids = annotationsHook.annotations.map(ann => ann.uuid);
        const id = ids.find(id => id?.endsWith(idOrShortId));
        if (!id) return;
        const selectedAnnotationIds: Set<string> = new Set();
        selectedAnnotationIds.add(id);
        labelerStateHook.setSelectedAnnotationIds(selectedAnnotationIds);
      } else if (activationEffect.type === 'setGISColorMode') {
        labelerStateHook.displayerOptions.imageGLDisplayerStateHook.setPreprocessingOptionIdx(
          colorMapToGLPreprocessingIds[activationEffect.target as string] || 0,
        );
        alertActivationEffect(`Set Color Mode to ${activationEffect.target}`);
      } else if (activationEffect.type === 'setVisibleLabels') {
        const allGroupLabelNodes = _.filter(
          getPreorderTraversal(labelerStateHook.annotationsHook.groupedAnnotationsTree),
          o => isLabelGroupNode(o),
        );
        const targetLabels = activationEffect.target as string[];
        const selectedGroupLabelNodes = _.filter(allGroupLabelNodes, o => {
          return isLabelGroupNode(o) && targetLabels.includes(o.label);
        });
        const unselectedGroupLabelsNodes = _.filter(allGroupLabelNodes, o => {
          return !(isLabelGroupNode(o) && targetLabels.includes(o.label));
        });

        if (selectedGroupLabelNodes) {
          labelerStateHook.annotationVisibilityHook.setVisibleAndHidden(
            selectedGroupLabelNodes.map(node => node.id),
            unselectedGroupLabelsNodes.map(node => node.id),
          );
        } else {
          labelerStateHook.annotationVisibilityHook.setVisibleAndHidden(
            allGroupLabelNodes.map(node => node.id),
            [],
          );
        }
      }
    });

    const hasSetVisibleLabel = _.map(activeStep?.activationEffects, effect => effect.type).includes(
      'setVisibleLabels',
    );

    if (!hasSetVisibleLabel) {
      labelerStateHook.annotationVisibilityHook.clearHiddenNodes();
    }
  }, [workflowState]);
};
export default useWorkflowStepActivationEffects;
